var menuanimating = false; 
jQuery(document).ready(function ($) {
	// The structure of the navigation should be
	// <ul id="top_nav">
	//	<li>
	//		<a href=""></a>
	//		<div class="subnav">
	//			<ul>
	//				<li>
	//					<a href=""></a>

	// jQuery HoverIntent must be installed
	// The mobile menu button should have the class "menu_button"

	// This bit handles hovering over the main navigation top level items (if the menu button is hidden)
	// the click part handles touch devices, so the first click with with the subnav hidden opens the subnav. Clicking again fires the link.
	$('#top_nav > li').has('.sub_nav')
		.hoverIntent({
			over: function () {
				if ($('.menu_button').is(":hidden")) {
					doNavOpen(this);
				}
			},
			out: function () {
				if ($('.menu_button').is(":hidden")) {
					doNavClose(this);
				}
			},
			timeout: 200
		})
		.click(function (e) {
			if ($('.menu_button').is(":hidden")) {
				if ($(this).children('.sub_nav').is(":hidden")) {
					e.stopPropagation();
					doNavOpen(this);
					return false;
				}
			}
		})
	;

	// if you give an element (the mobile menu button) the class "expander" it will expand and contract the element defined by its data-expand attribute
	// those expandable elements must have the class "expandable"
	// the button should have the following attributes data-icon1="fa-bars" data-icon2="fa-times" where icon1 is the default icon and icon2 is the opened icon
	$('.expander').click(function (event) {
		var clicked_elem = this;
		// close anything that isn't THIS
		$('.expander').each(function (event) {
			if (this != clicked_elem && $(this).is(":visible")) {
				contract(this);
			}
		});
		xtoggle(event,this);
		return false;
	});

	// this closes an expanded item such as dropdown nav if you click anywhere outside that area
	$(document).on("click touchstart", function (e) {
		// if clicking anywhere but the expanding box or the button that triggers it
		if (!$(e.target).is(".expandable") && !$(".expandable").has(e.target).length > 0 && !$(e.target).is(".expander") && !$(".expander").has(e.target).length > 0) {
			doNavClose($('#top_nav > li'));
			$('.expander').each(function () {
				expanding = $(this).data('expand');
				if ( $(this).is(':visible') && $('.' + expanding).is(':visible') ) {
					contract(this);
				}
			});
		}
	});

});

function contract(target) {
	expanding = $(target).data('expand');
	var icon1 = $(target).data('icon1');
	var icon2 = $(target).data('icon2');
	$('.' + expanding).slideUp();

	if ($('i', target).hasClass(icon2)) {
		$('i', target).addClass("spin");
		setTimeout(function () {
			$('i', target).removeClass("spin");
			menuanimating = false;
		}, 300);
		setTimeout(function () {
			$('.' + expanding + ' > ul > li').css("opacity", 0);
			$('.' + expanding).removeClass("is-open");
		}, 301);
		$('i', target).addClass(icon1).removeClass(icon2);
	}

}

function xtoggle(event, target) {
	var expand = $(target).data('expand');
	var icon1 = $(target).data('icon1');
	var icon2 = $(target).data('icon2');
	
	if (!menuanimating) {
		menuanimating = true;
		event.stopPropagation();
		$('.' + expand).slideToggle({
			speed: 300,
			start: function () {

			}
		  });
		$('.'+expand).toggleClass("is-open");
		$('i', target).toggleClass(icon1).toggleClass(icon2);
		$('i', target).addClass("spin");
		setTimeout(function () {
			$('i', target).removeClass("spin");
			menuanimating = false;
		}, 300);
		
	}
	if ($('.' + expand).hasClass("is-open")) {
		$('.' + expand + ' > ul > li').css("opacity", 0);
		setTimeout(function () {
			$('.'+expand + ' > ul > li').each(function (indexInArray) {
				var item = $(this);
				setTimeout(function () {
					item.animate({
						opacity: 1
					}, 300, 'swing');
				}, 100 + (50 * indexInArray));
			});
		}, 101);
	} else {
		setTimeout(function () {
			$('.'+expand + ' > ul > li').css("opacity", 0);
		}, 301);
	}
}

function doNavOpen(thing) {
	$(thing).children('.sub_nav').slideDown(300);
}

function doNavClose(thing) {
	$(thing).removeClass("active");
	if ($('.menu_button').is(":hidden")) {
		$(thing).children('.sub_nav').slideUp(300);
	} else {
		$(thing).children('.sub_nav').slideUp(300);
	}
}